// IMPORT BASE-MODULE
import BaseModule from "@core/modules/base-module/base-module";
import TeaserSlider from "@pj/components/snap-sliders/teasers-snap-slider/teasers-snap-slider";

const viewMoreModule = new BaseModule();
viewMoreModule.name = "teasers-with-contact";
viewMoreModule.init((that)=>{
  const slider=new TeaserSlider();
  slider.init(that.elements);
});
